import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import './Teams.css';

const TeamsDetails = ({data}) => {
    const {name, title, img, facebook, twyter, linkdine, description} = data;
    return (
    <div class="flip-card mb-5">
        <div class="flip-card-inner">
          <div class="flip-card-front teamSection">
            <img src={img}  alt="Avatar"/>
            <h5 className="text-white">{name}</h5>
            <h6 className="text-white">{title}</h6>
          </div>
          <div class="flip-card-back">
            <p className="pt-5">{description}</p>
           <div className="d-flex teamIcon">
           <li className="icon-group"><FontAwesomeIcon icon={facebook}/></li>
            <li className="icon-group"><FontAwesomeIcon icon={twyter}/></li>
            <li className="icon-group"><FontAwesomeIcon icon={linkdine}/></li>
           </div>
         </div>
        </div>
      </div>
    );
};

export default TeamsDetails;